module.exports = __webpack_public_path__ + "img/training_system.a913df36.jpg";